import React from "react";
import ContentListPage from "@/components/ContentListPage";

export default function CaseReports() {
  return (
    <ContentListPage
      type="case_report"
      routeBase="/case-reports"
      eyebrow="Clinical Case Reports"
      title={<>Real patients. <span className="italic text-[#E07A5F]">Real recoveries.</span></>}
      subtitle="A curated selection of anonymised clinical case reports from our practice — documenting how modern neuropsychiatry, deaddiction and interventional neuromodulation are changing lives."
      seoTitle="Case Reports — rTMS, Deaddiction, Neuropsychiatry"
      seoDescription="Anonymised clinical case reports from Manas Neuropsychiatry Hospital, Bhavnagar — treatment-resistant depression, deaddiction, OCD, sexual health and neuromodulation outcomes."
      testIdPrefix="case"
    />
  );
}
